var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pwa-prompt-box" },
    [
      _c(
        "div",
        {
          staticClass: "pwa-prompt-wrap",
          class: { active: _vm.deferredPrompt },
        },
        [
          _c(
            "a",
            {
              staticClass: "btn btn-install",
              attrs: { href: "javascript:;" },
              on: { click: _vm.goInstall },
            },
            [
              _vm._v(_vm._s(_vm.$t("title_install_bonus"))),
              _c("em", { staticClass: "icon" }),
            ]
          ),
        ]
      ),
      _vm.isShowPopupInstallBonus && _vm.deferredPrompt
        ? _c("PopupInstallBonus", {
            attrs: { showType: _vm.popupType },
            on: {
              pwaInstall: function ($event) {
                return _vm.goInstall("bonus")
              },
            },
          })
        : _vm._e(),
      _c("ArrivalPanel", {
        style: { left: _vm.showArrivalPanel ? "0" : "101%" },
        attrs: { "is-show": _vm.showArrivalPanel, options: { type: "pwa" } },
        nativeOn: {
          click: function ($event) {
            _vm.showArrivalPanel = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }